import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  QuestionLabel,
  Container,
  TextError,
} from '../styles';
import PreferenceOption from './preference-option';

const PreferenceQuestionType = (props) => {
  const {
    label,
    questionOptions,
    onChange,
    selectedValue,
    errorField,
    errorText,
  } = props;

  const options = useMemo(() => _.orderBy(questionOptions, ['order'], ['asc']), [questionOptions]);

  const handleClickRadioOption = (idQuestion) => {
    onChange({ [idQuestion]: true });
  };

  return (
    <Container>
      <QuestionLabel>{label}</QuestionLabel>
      <div>
        {_.map(options, (option) => (
          <PreferenceOption
            onSelect={() => handleClickRadioOption(option.id)}
            option={option}
            selected={!!selectedValue[option.id]}
          />
        ))}
        {
          errorField && (
            <TextError>
              {errorText}
            </TextError>
          )
        }
      </div>
    </Container>
  );
};

PreferenceQuestionType.propTypes = {
  label: PropTypes.string.isRequired,
  questionOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    id: PropTypes.string,
    imageUrl: PropTypes.string,
    order: PropTypes.number,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  selectedValue: PropTypes.shape({}).isRequired,
  errorField: PropTypes.bool,
  errorText: PropTypes.string,
};

PreferenceQuestionType.defaultProps = {
  errorField: false,
  errorText: 'Please select an answer',
};

export default PreferenceQuestionType;
